<template>
  <b-container v-if="createAny('users') && currentUserIsSuperAdmin()" fluid>
    <!-- TItle bar -->
    <div class="title-bar">
      <h1>{{ $t("buttons.emailtemplates") }}</h1>
    </div>

    <!-- Hours filled -->
    <h2 class="mt-5">{{ $t("templates.hoursfilled") }}</h2>
    <p>{{ $t("templates.hoursfilledexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.hoursfilledsubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.hoursfilledmessage" :config="editorConfig"></ckeditor>
    </b-form-group>
    <div class="form-row">
      <div class="col-3">
        {{ $t("titles.reviewquestions") }}
      </div>
      <div class="col-8">
        <v-select :options="this.reviewrequests" label="description" v-model="settings.reviewquestions" />
      </div>
    </div>
    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>
    <!-- Hours checked -->
    <h2 class="mt-5">{{ $t("templates.hourschecked") }}</h2>
    <p>{{ $t("templates.hourscheckedexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.hourscheckedsubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.hourscheckedmessage" :config="editorConfig"></ckeditor>
    </b-form-group>
    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>
    <!-- Purchase invoice -->
    <h2 class="mt-5">{{ $t("templates.purchase") }}</h2>
    <p>{{ $t("templates.purchaseexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.purchasesubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.purchasemessage" :config="editorConfig"></ckeditor>
    </b-form-group>
    <b-form-group :label="$t('labels.sendcc')">
      <b-form-input type="text" class="form-control" v-model="settings.purchasecc" />
    </b-form-group>
    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>
    <!-- Sale invoice -->
    <h2 class="mt-5">{{ $t("templates.sale") }}</h2>
    <p>{{ $t("templates.saleexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.salesubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.salemessage" :config="editorConfig"></ckeditor>
    </b-form-group>
    <b-form-group :label="$t('labels.sendcc')">
      <b-form-input type="text" class="form-control" v-model="settings.salecc" />
    </b-form-group>
    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>

    <!-- purchase invoice -->
    <h2 class="mt-5">{{ $t("templates.combinedpurchase") }}</h2>
    <p>{{ $t("templates.combinedpurchaseexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.combinedpurchasesubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.combinedpurchasemessage" :config="editorConfig"></ckeditor>
    </b-form-group>
    <b-form-group :label="$t('labels.sendcc')">
      <b-form-input type="text" class="form-control" v-model="settings.combinedpurchasecc" />
    </b-form-group>

    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>

    <!-- Sale invoice -->
    <h2 class="mt-5">{{ $t("templates.combinedsale") }}</h2>
    <p>{{ $t("templates.combinedsaleexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.combinedsalesubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.combinedsalemessage" :config="editorConfig"></ckeditor>
    </b-form-group>
    <b-form-group :label="$t('labels.sendcc')">
      <b-form-input type="text" class="form-control" v-model="settings.combinedsalecc" />
    </b-form-group>

    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>

    <!-- No Hours filled reminder -->
    <h2 class="mt-5">{{ $t("templates.nohoursfilled") }}</h2>
    <p>{{ $t("templates.nohoursfilledexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.nohoursfilledsubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.nohoursfilledmessage" :config="editorConfig"></ckeditor>
    </b-form-group>
    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>

    <!-- Hours not signed reminder -->
    <h2 class="mt-5">{{ $t("templates.notsigned") }}</h2>
    <p>{{ $t("templates.notsignedexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.notsignedsubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.notsignedmessage" :config="editorConfig"></ckeditor>
    </b-form-group>

    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>

    <!-- Reset password -->
    <h2 class="mt-5">{{ $t("templates.passwordreset") }}</h2>
    <p>{{ $t("templates.passwordresetexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.passwordresetsubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.passwordresetmessage" :config="editorConfig"></ckeditor>
    </b-form-group>

    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>

    <!-- Subscription ZZPer password -->
    <h2 class="mt-5">{{ $t("templates.subscriptionzzpr") }}</h2>
    <p>{{ $t("templates.subscriptionzzprexplain") }}</p>
    <b-form-group :label="$t('templates.subject')">
      <b-form-input type="text" class="form-control" v-model="settings.subscribezzprsubject" />
    </b-form-group>
    <b-form-group :label="$t('templates.message')">
      <ckeditor :editor="editor" v-model="settings.subscribezzprmessage" :config="editorConfig"></ckeditor>
    </b-form-group>

    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>
    <!-- footer  -->
    <h2 class="mt-5">{{ $t("titles.emailheader") }}</h2>
    <div>
      <b-form-textarea rows="8" type="text" class="form-control" v-model="settings.generalheader" />
    </div>
    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>
    <!-- email header -->
    <h2 class="mt-5">{{ $t("titles.emailheaderimage") }}</h2>
    <div class="row">
      <div class="col">
        <img style="width: 100%" src="/api/media_main_documents/ALG_Main_header.png" />
      </div>
      <div class="col">
        <div class="row">
          <div class="col-3">
            <label for=""> {{ $t("labels.file") }}</label>
          </div>
          <div class="col">
            <b-form-file ref="file-input" class="form-control" accept="*/*" v-model="file1" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div v-if="file1" class="btn btn-primary" @click="my_add_document()">{{ $t("buttons.replace") }}</div>
        </div>
      </div>
    </div>
    <!-- Email signature -->
    <h2 class="mt-5">{{ $t("titles.signature") }}</h2>
    <div id="app">
      <ckeditor :editor="editor" v-model="settings.signature" :config="editorConfig"></ckeditor>
    </div>
    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>
    <!-- footer  -->
    <h2 class="mt-5">{{ $t("titles.emailfooter") }}</h2>
    <div>
      <b-form-textarea rows="8" type="text" class="form-control" v-model="settings.generalfooter" />
    </div>
    <!-- subject confirm -->
    <h2 class="mt-5">{{ $t("templates.sendcontractheader") }}</h2>
    <p>{{ $t("templates.sendcontractexplain") }}</p>
    <b-form-group :label="$t('templates.subject') + ' ' + $t('buttons.sendconfirm')">
      <b-form-input type="text" class="form-control" v-model="settings.subjecttemplateconfirm" />
    </b-form-group>
    <b-form-group :label="$t('templates.subject') + ' ' + $t('buttons.sendcontract')">
      <b-form-input type="text" class="form-control" v-model="settings.subjecttemplatecontract" />
    </b-form-group>
    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="plus" /> {{ $t("buttons.savesettings") }}</div>
  </b-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import axios from "axios";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "settings-screen",
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: ["heading", "|", "undo", "redo", "-", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "insertTable"],
          shouldNotGroupWhenFull: true,
        },
        heading: {
          options: [
            { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
            { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
            { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
          ],
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
      },
      subject: ",mn,ndn nfklajljflaj kls",
      selected: [],
      file1: null,
      reviewrequests: [],
    };
  },
  mounted() {
    axios
      .get("/api/reviewrequest/all")
      .then((response) => {
        this.reviewrequests = response.data;
      })
      .catch(() => {});
  },
  computed: {
    ...mapState(["settings", "users", "contracts", "hours"]),
    ...mapGetters(["server_url", "username_by_id", "user_by_id", "project_by_id", "contract_by_id", "company_by_id", "factuur_by_id", "confirm_modal", "planning_by_id", "createAny"]),
  },
  methods: {
    ...mapActions([]),
    my_add_document() {
      const formData = new FormData();
      formData.append("file", this.file1);
      try {
        axios.post("/api/emailheader/", formData).then((response) => {
          console.log("succes", response);
        });
      } catch (err) {
        console.log(err);
      }
    },
    save_settings() {
      try {
        axios
          .patch("/api/settings/", {
            signature: this.settings.signature,
            hoursfilledmessage: this.settings.hoursfilledmessage,
            hoursfilledsubject: this.settings.hoursfilledsubject,
            hourscheckedmessage: this.settings.hourscheckedmessage,
            hourscheckedsubject: this.settings.hourscheckedsubject,
            salemessage: this.settings.salemessage,
            salesubject: this.settings.salesubject,
            combinedsalemessage: this.settings.combinedsalemessage,
            combinedsalesubject: this.settings.combinedsalesubject,
            combinedpurchasemessage: this.settings.combinedpurchasemessage,
            combinedpurchasesubject: this.settings.combinedpurchasesubject,
            purchasemessage: this.settings.purchasemessage,
            purchasesubject: this.settings.purchasesubject,
            nohoursfilledsubject: this.settings.nohoursfilledsubject,
            nohoursfilledmessage: this.settings.nohoursfilledmessage,
            notsignedmessage: this.settings.notsignedmessage,
            notsignedsubject: this.settings.notsignedsubject,
            generalheader: this.settings.generalheader.replace(/\n|\r/g, ""),
            generalfooter: this.settings.generalfooter.replace(/\n|\r/g, ""),
            passwordresetmessage: this.settings.passwordresetmessage,
            passwordresetsubject: this.settings.passwordresetsubject,
            subscribezzprsubject: this.settings.subscribezzprsubject,
            subscribezzprmessage: this.settings.subscribezzprmessage,
            salecc: this.settings.salecc,
            combinedsalecc: this.settings.combinedsalecc,
            combinedpurchasecc: this.settings.combinedpurchasecc,
            purchasecc: this.settings.purchasecc,
            subjecttemplateconfirm: this.settings.subjecttemplateconfirm,
            subjecttemplatecontract: this.settings.subjecttemplatecontract,
            reviewquestions: this.settings.reviewquestions,
          })
          .then((response) => {
            console.log(response);
          });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
